/* eslint-disable import/extensions */

import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { TextField, Autocomplete } from '@masfront/common-b2c'
import { Form, FastField, Formik } from 'formik'

import { makeStyles, Card, Box, Typography, Divider, Grid, MenuItem } from '@material-ui/core'

import contactSchema from './ContactForm.schemas'
import provinces from './provinces'
import useContactForm from './useContactForm'

import useClientFieldValues from '../../hooks/useClientFieldValues'
import { selectCustomerContactValues } from '../../store/customer.selectors'

import { selectIsOffline } from '~/agent/store/agent.selectors'
import { selectLanguages } from '~/masterData/store/masterData.selectors'

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiFormControl-root': {
      width: '100%',
    },
  },
}))

function Contact() {
  const { checkExistentCustomerValues } = useClientFieldValues()
  const { root } = useStyles()
  const isOffline = useSelector(selectIsOffline)
  const languages = useSelector(selectLanguages)

  const sortedProvinces = useMemo(
    () =>
      provinces.sort((a, b) => {
        return a.value.localeCompare(b.value)
      }),
    [provinces],
  )

  useContactForm()

  return (
    <Card elevation={5} className={root}>
      <Box py={5} px={6}>
        <Typography variant="h3">Datos de contacto</Typography>
      </Box>
      <Divider />
      <Box px={6} pb={6} mt={6}>
        <Form>
          <Grid container component={Box} spacing={5}>
            <Grid xs={4} item>
              <FastField
                component={TextField}
                name="email"
                label="Email de contacto"
                variant="outlined"
              />
            </Grid>
            <Grid xs={4} item>
              <FastField
                disabled={checkExistentCustomerValues('language')}
                component={TextField}
                name="language"
                label="Idioma"
                variant="outlined"
                select
              >
                {languages?.map(({ value, id }) => (
                  <MenuItem value={value} key={`language-${id}`}>
                    {value}
                  </MenuItem>
                ))}
              </FastField>
            </Grid>
            {isOffline && (
              <Grid xs={4} item>
                <FastField
                  component={Autocomplete}
                  disabled={checkExistentCustomerValues('province')}
                  name="province"
                  label="Provincia"
                  variant="outlined"
                  autoComplete={false}
                  noOptionsText="No se encontraron provincias"
                  options={sortedProvinces}
                  getOptionLabel={(option: { id: string; value: string }) => option.value || ''}
                  renderOption={(option: { id: string; value: string }) => (
                    <span key={option.id}>{option.value}</span>
                  )}
                  getOptionSelected={(option: { id: string; value: string }) => option.id}
                />
              </Grid>
            )}
          </Grid>
        </Form>
      </Box>
    </Card>
  )
}

export default function ContactForm() {
  const isOffline = useSelector(selectIsOffline)

  const contactFormSchema = contactSchema(isOffline)
  const contactValues = useSelector(selectCustomerContactValues)

  return (
    <>
      <Formik
        initialValues={contactValues}
        initialStatus={{}}
        validateOnBlur={false}
        validateOnMount
        validationSchema={contactFormSchema}
        onSubmit={(values, formik) => {
          formik.setSubmitting(false)
        }}
        component={Contact}
      />
    </>
  )
}
